import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=40bc2501&"
import script from "./OrganizationChart.vue?vue&type=script&lang=js&"
export * from "./OrganizationChart.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports